<ion-content class="contacts">
  <ng-container>
    <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Contacts'" [breadcrumbs]="breadcrumbs"></app-header>

    <ion-grid  style=" padding-top:120px">
      <div class="div-container">
        <ion-row>
          <ion-header>Contacts</ion-header>
        </ion-row>
        <div class="loading-container" *ngIf="!loaded">
          <ion-spinner></ion-spinner>
      </div>
        <ion-row>
          <div class="table-row">
            <ngx-datatable
              class="bootstrap"
              [rows]="contacts"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
              <ngx-datatable-column name="Name" prop="name">
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-value="value"
                >
                  <a
                    ><span *ngIf="row.recievesEmails" class="receives-emails"
                      >*</span
                    >&nbsp;{{value}} <span *ngIf="row.description">({{row.description}}) </span></a
                  >
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Phone" prop="phone">
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a [href]="'tel:' + value" class="link">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Email" prop="email">
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a [href]="'mailto:' + value" class="link">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </ion-row>

        <ion-row>
          <ion-header>Other Contacts</ion-header>
        </ion-row>
        <ion-row>
          <div class="table-row">
            <ngx-datatable
              class="bootstrap"
              [rows]="otherContacts"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
              <ngx-datatable-column name="Name" prop="name">
                <ng-template
                ngx-datatable-cell-template
                let-row="row"
                let-value="value"
              >
                  <a>{{value}} <span *ngIf="row.description">({{row.description}})</span></a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Phone" prop="phone">
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a [href]="'tel:' + value" class="link">{{value}}</a>
                </ng-template></ngx-datatable-column
              >
              <ngx-datatable-column name="Email" prop="email">
                <ng-template ngx-datatable-cell-template let-value="value">
                  <a [href]="'mailto:' + value" class="link">{{value}}</a>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </ion-row>
        <ion-row class="bottom-message">
          <ion-col>
            <span class="receives-emails">*</span> Receives Emails For Stop
          </ion-col>
        </ion-row>
      </div>
    </ion-grid>
  </ng-container>
</ion-content>
